<template>
  <div class="commission-detail-section">
    <div class="section-header" @click="isOpen = !isOpen">
      <div class="section-title">
        <span class="collapse-icon">
          <i class="fa fa-minus-circle"></i>
        </span>
        <img v-if="!isOpen" src="@/assets/img/ac_1.gif" alt="Open" class="mr-4" style="width: 15px; height: 15px;" />
        <img v-else src="@/assets/img/ac_2.gif" alt="Open" class="mr-4" style="width: 15px; height: 15px;" />
        月度コミッション
      </div>
      <div class="amount">{{ commissionData.paymentAmount }}円</div>
    </div>
    
    <div class="section-content" v-show="isOpen">
      <table class="commission-table">
        <tbody>
          <!-- コミッション明細データ -->
          <tr>
            <td>通常コミッション</td>
            <td class="text-right">{{ commissionData.normal }}円</td>
          </tr>
          <tr>
            <td>J同格コミッション</td>
            <td class="text-right">{{ commissionData.j }}円</td>
          </tr>
          <tr>
            <td>傘下V育成コミッション</td>
            <td class="text-right">
              {{ commissionData.subsidiary }}円
              <button 
                v-if="commissionData.hasSubsidiaryCommission" 
                class="detail-button"
                @click.stop="$emit('show-subsidiary')"
              >
                傘下V育成コミッション明細
              </button>
            </td>
          </tr>
          <tr>
            <td>調 整 金</td>
            <td class="text-right">{{ commissionData.adjustment }}円</td>
          </tr>
          <tr>
            <td>返 品 分</td>
            <td class="text-right">{{ commissionData.return }}円</td>
          </tr>
          
          <!-- 税額計算 -->
          <tr>
            <td>①コミッション合計金額(税込)</td>
            <td class="text-right">{{ commissionData.totalWithTax }}円</td>
          </tr>
          <tr>
            <td>コミッション合計金額(10%税抜)</td>
            <td class="text-right">{{ commissionData.totalWithoutTax }}円</td>
          </tr>
          <tr>
            <td>コミッション合計金額(消費税)</td>
            <td class="text-right">{{ commissionData.consumptionTax }}円</td>
          </tr>
          <tr>
            <td>②経過措置額(10%税抜)</td>
            <td class="text-right">{{ commissionData.transitionalWithoutTax }}円</td>
          </tr>
          <tr>
            <td>③経過措置額(消費税)</td>
            <td class="text-right">{{ commissionData.transitionalTax }}円</td>
          </tr>
          
          <!-- 源泉徴収 -->
          <tr>
            <td>④源泉徴収税額</td>
            <td class="text-right">{{ commissionData.withholdingTax }}円</td>
          </tr>
          
          <!-- 支払額計算 -->
          <tr>
            <td v-if="!commissionData.hasRegistrationNumber">合計(①-②-③-④) ※80%控除対象</td>
            <td v-else>合計(①-②-③-④)</td>
            <td class="text-right">{{ commissionData.totalAfterDeductions }}円</td>
          </tr>
          <tr>
            <td>通知書発行手数料</td>
            <td class="text-right">{{ commissionData.notificationFee }}円</td>
          </tr>
          <tr class="total-row">
            <td>お支払金額</td>
            <td class="text-right amount">{{ commissionData.paymentAmount }}円</td>
          </tr>
        </tbody>
      </table>
      
      <!-- 標準の注意書き -->
      <StandardNotes :fiscalYear=fiscalYear />

    </div>
  </div>
</template>

<script>
import StandardNotes from "@/views/details/components/StandardNotes.vue";
export default {
  name: 'CommissionDetailSection',
  components: {
    StandardNotes
  },
  props: {
    commissionData: {
      type: Object,
      required: true
    },
    display: {
      type: String,
      default: "0",
    },
    fiscalYear: {
      type: String,
      default: '0'
    },
    amount: {
      type: String,
      default: "0",
    },
    amountHead: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {
      isOpen: false
    };
  },
  watch: {
      commissionData() {
        this.isOpen = false;
      },
  }
};
</script>

<style scoped>
.commission-detail-section {
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: #f5f5f5;
  cursor: pointer;
  border-radius: 4px 4px 0 0;
}

.section-title {
  font-weight: 600;
  display: flex;
  align-items: center;
}

.collapse-icon {
  margin-right: 10px;
  color: #666;
}

.amount {
  font-weight: bold;
}

.section-content {
  padding: 15px;
}

.commission-table {
  width: 100%;
  border-collapse: collapse;
}

.commission-table th, .commission-table td {
  padding: 8px 15px;
  border-bottom: 1px solid #ddd;
}

.commission-table th {
  background-color: #f0f0f0;
  text-align: center;
}

.commission-table tr td:first-child {
  min-width: 320px;
}

.item-col {
  width: 70%;
}

.amount-col {
  width: 30%;
}

.text-right {
  text-align: right;
}

.sub-header {
  background-color: #f9f9f9;
  font-weight: 600;
}

.total-row {
  background-color: #f0f0f0;
  font-weight: 600;
}

.total-row .amount {
  color: #e74c3c;
}

/* .detail-button {
  margin-left: 10px;
  padding: 2px 8px;
  background-color: #f9f9f9;
  color: white;
  border: none;
  border-radius: 3px;
  font-size: 0.8rem;
  cursor: pointer;
}

.detail-button:hover {
  background-color: #2980b9;
} */


/* スマートフォンレイアウト */
@media screen and (min-width: 1px) and (max-width: 991px) {
  .section-content {
    padding: 0px;
  }
  .commission-table tr td:first-child {
    min-width: inherit;
  }
}

</style> 